import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Modal from '../Modal';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { fetchManagers } from '@/redux/managersSlice';
import useAuth from '@/hooks/useAuth.hook';
import { fetchAffiliates } from "@/redux/affiliatesSlice";

// Компонент для фильтров
const Filters = ({ applyChanges, defaultFilters }) => {
    const { token } = useAuth();
    const [fields, setFields] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [tempFilters, setTempFilters] = useState({});
    const [localFilters, setLocalFilters] = useState({});
    const { desks, status } = useSelector(state => state.desk)
    const { retens, status: retenStatus } = useSelector(state => state.reten)
    const { sales, status: salesStatus } = useSelector(state => state.sale)
    const { filters } = useSelector(state => state.leads)
    const { managers, status: managerStatus } = useSelector(state => state.manager)
    const { affiliates, status: affStatus } = useSelector((state) => state.affiliates);

    const dispatch = useDispatch();

    const openModal = () => {
        const initialFilters = {};
        setIsModalOpen(true);
    };

    const closeModal = () => setIsModalOpen(false);

    const applyFilters = () => {
        applyChanges(localFilters, closeModal)
    };

    useEffect(() => {
        if (managerStatus === 'idle' && token) {
            dispatch(fetchManagers({
                token: token
            }))
        }

        if (affStatus === 'idle')
            dispatch(fetchAffiliates({ token }))

    }, [token]);

    const handleFilterChange = (key, selectedOption, type) => {
        // console.log('handleFilterChange: ', key, selectedOption, type)
        const filterObj = {};

        if (type === 'multy_select') {
            const currentFilterValues = filters[key]?.split(',') || [];
            const newFilterValues = selectedOption.map(option => option.value);

            // Add new values to the filter
            const updatedFilterValues = [...newFilterValues];

            // Remove duplicate values
            const uniqueFilterValues = [...new Set(updatedFilterValues)];

            filterObj[key] = uniqueFilterValues.join(',');
        } else {
            filterObj[key] = selectedOption.value;
        }

        // Update the filters
        const updatedFilters = { ...localFilters, ...filterObj };
        setLocalFilters(updatedFilters)
        // dispatch(fetchTransactions({ token, limit: 10, offset: 0, filters: updatedFilters }));
    };

    useEffect(() => {
        setFields(prev => {
            const newFilters = [];
            // add affiliates
            if (affiliates.length) {
                newFilters.push({
                    label: 'Партнер', key: "affiliate_id", type: 'multy_select', defaultValue: 'all',
                    options: [{ label: 'Все', value: 'all' }, ...affiliates.map(affiliate => ({ label: affiliate.first_name + ' ' + affiliate.last_name, value: affiliate.id }))]
                })
            }
            // add desks
            if (desks.length) {
                newFilters.push({
                    label: 'Деск', key: "desk_leads", type: 'multy_select', defaultValue: 'all',
                    options: [{ label: 'Все', value: 'all' }, ...desks.map(desk => ({ label: desk.name, value: desk.name }))]
                })
            }

            // add reten
            if (retens.length)
                newFilters.push({
                    label: 'Reten', key: "reten_status", type: 'multy_select', defaultValue: 'all',
                    options: [{ label: 'Все', value: 'all' }, ...retens.map(reten => ({ label: reten.name, value: reten.name }))]
                })

            // add sale
            if (sales.length)
                newFilters.push({
                    label: 'Sale', key: "sale_status", type: 'multy_select', defaultValue: 'all',
                    options: [{ label: 'Все', value: 'all' }, ...sales.map(sale => ({ label: sale.name, value: sale.name }))]
                })

            if (managers.length)
                newFilters.push({
                    label: 'Менеджер', key: "lead_manager", type: 'multy_select', defaultValue: 'all',
                    options: [{ label: 'Все', value: 'all' }, ...managers.map(manager => ({ label: manager.full_name, value: manager.full_name }))]
                });

            newFilters.push({
                label: 'FTD', key: "fdt_leads", type: 'select', defaultValue: 'all',
                options: [{ label: 'Все', value: 'all' }, { label: 'Yes', value: 'true' }, { label: 'No', value: 'false' }]
            });

            newFilters.push(...[
                {
                    label: 'Подтверждение Личности', key: "photo_passport", type: 'select', defaultValue: 'all',
                    options: [{ label: 'none', value: '' }, { label: 'Pending', value: 'false' }, { label: 'Verified', value: 'true' }]
                },
                {
                    label: 'Подтверждение Адреса', key: "photo_address", type: 'select', defaultValue: 'all',
                    options: [{ label: 'none', value: '' }, { label: 'Pending', value: '0' }, { label: 'Verified', value: '1' }]
                },
                {
                    label: 'Карта (фронтальная):', key: "photo_card_front", type: 'select', defaultValue: 'all',
                    options: [{ label: 'none', value: '' }, { label: 'Pending', value: '0' }, { label: 'Verified', value: '1' }]
                },
                {
                    label: 'Карта (обратная):', key: "photo_card_back", type: 'select', defaultValue: 'all',
                    options: [{ label: 'none', value: '' }, { label: 'Pending', value: '0' }, { label: 'Verified', value: '1' }]
                },
                {
                    label: 'Место Работы:', key: "photo_employment", type: 'select', defaultValue: 'all',
                    options: [{ label: 'none', value: '' }, { label: 'Pending', value: '0' }, { label: 'Verified', value: '1' }]
                }
            ])

            return newFilters;
        })
    }, [status, managerStatus, retenStatus, salesStatus, affStatus]);
    // Здесь должна быть логика для обработки изменений фильтра

    console.log("filters: ", filters)
    return (<>
        <button onClick={openModal} className="h-fit bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">Фильтры</button>
        <Modal isOpen={isModalOpen || false} onClose={closeModal}>
            <Modal.Header>
                Фильтры
            </Modal.Header>
            <Modal.Body>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
                    {fields.map(({ label, key, type, defaultValue, options }) => <div key={key}>
                        <label className="block text-gray-700 text-sm font-bold mb-2">{label}</label>
                        <Select
                            isMulti={type === 'multy_select' ? true : undefined}
                            onChange={(selectedOption) => handleFilterChange(key, selectedOption, type)}
                            options={options}
                            defaultValue={
                                type === 'multy_select'
                                    ? filters[key]?.split(',').map(value => options.find(option => option.value == value)) || []
                                    : options.find(option => option.value === filters[key]) || null
                            }
                        />
                    </div>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button onClick={applyFilters} className="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">Применить</button>
            </Modal.Footer>
        </Modal>
    </>
    );
};

export default Filters;